import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { DEFAULT_QUICK_IDS } from '../hooks/useNavigation'

/**
 * Quick Actions Store — de personaliseerbare snelknoppen-set (BLOK 3).
 *
 * Bewaart WELKE vensters in de snelknoppenbalk staan (lijst van venster-id's = href's uit de
 * vensterregistratie, SSOT). localStorage-persist, patroon consistent met navPanelStore/themeStore.
 * BLOK 4 sync't deze voorkeur naar de backend; tot dan is dit de bron.
 *
 * Default = de afgesproken zes (DEFAULT_QUICK_IDS). De volgorde in `quickIds` = de toonvolgorde in de balk.
 */
export const useQuickActionsStore = create(
  persist(
    (set) => ({
      quickIds: [...DEFAULT_QUICK_IDS],

      // Toggle één venster in/uit de balk (volgorde: nieuw = achteraan).
      toggleQuick: (id) =>
        set((s) => ({
          quickIds: s.quickIds.includes(id)
            ? s.quickIds.filter((x) => x !== id)
            : [...s.quickIds, id],
        })),

      // Vervang de hele set (bv. vanuit een backend-sync in BLOK 4).
      setQuick: (ids) => set({ quickIds: Array.isArray(ids) ? [...ids] : [] }),

      // Terug naar de default-zes.
      resetQuick: () => set({ quickIds: [...DEFAULT_QUICK_IDS] }),
    }),
    { name: 'orion-quick-actions', version: 1 },
  ),
)
